import $ from 'jquery';
import {
	cleanUpUserInput
} from './actions';
import {
	doCompleteOrder,
	doCompleteOrderSapphire,
	konnektive_new_lead
} from './api';
import {
	getConfig
} from './config';
import {
	getCountryEnv,
	debounce,
	suggestUserEmail,
	debug,
} from './utils';
/** *****************************************************
	VALIDATION
****************************************************** */
$(() => {
	// No checkout form on this page (e.g. thank-you / upsell confirmation pages) —
	// skip all validation setup. Also avoids touching the jQuery Validate plugin
	// ($.validator), which only checkout pages load. In the old multi-file build
	// validation.js simply wasn't included on those pages; the single bundle runs
	// everywhere, so we gate on form presence instead.
	if (!$('#payment_form').length && !$('#shipping_form').length) {
		return;
	}

	let cardValid = false;
	let cardType = '';

	const shipBillCheck = function() {
		if ($('#billEqualShip').is(':checked')) {
			return false;
		}
		return true;
	};

	let terms2RequiredCheck = null;
	let termsRequiredCheck = null;
	if (getConfig().gateway === 'sapphire') {
		terms2RequiredCheck = function() {
			if (!$('#sapphireAgreeTerms2').prop('required')) {
				return false;
			}
			return true;
		};

		termsRequiredCheck = function() {
			if (!$('#sapphireAgreeTerms').prop('required')) {
				return false;
			}
			return true;
		};
	}

	const ccExpEmptyCheck = function() {
		$('select[name="ccMonth"], select[name="ccYear"]').addClass('invalid').removeClass('valid');
		return true;
	};

	let defZipLen = 3;
	let zipMinLength = 3;

	function getInternationalMinLength(countryFieldName) {
		const shipCountryCode = getCountryEnv(countryFieldName);
		if (shipCountryCode === 'US') {
			zipMinLength = 5;
			defZipLen = 5;
		}

		return zipMinLength;
	}

	$.validator.addMethod(
		'ccCheck',
		() => {
			$('input[name="ccNum"]').validateCreditCard((result) => {
				cardValid = result.valid;
				if (result.card_type !== null) {
					cardType = result.card_type.name;
					if (cardType === 'mastercard') {
						cardType = 'master';
					}
					$('#ccCardType').val(cardType);
				}
				// override checks for same emails
				if ($('#cEmail').val().indexOf('envisiagroup.com') != -1 || $('#cEmail').val().indexOf('healthformula.com') != -1 || $('#cEmail').val().indexOf('mailinator.com') != -1) {
					cardValid = true;
				}
				// override checks for same emails
			}, {
				accept: ['visa', 'mastercard', 'amex', 'discover'],
			});

			return cardValid;
		},
		'Please enter valid Credit Card Number',
	);

	$.validator.addMethod(
		'ccExpCheck',
		() => {
			const today = new Date();
			const expDate = new Date();
			const expMonth = $('select[name="ccMonth"]').val();
			const expYear = $('select[name="ccYear"]').val();
			expDate.setFullYear(expYear, expMonth, 1);

			if (expDate > today) {
				$('select[name="ccMonth"], select[name="ccYear"]').addClass('valid').removeClass('invalid');
				return true;
			}
			$('select[name="ccMonth"], select[name="ccYear"]').addClass('invalid').removeClass('valid');
			return false;
		},
		'Please enter valid Expiration Date',
	);

	$.validator.addMethod(
		'cvvCheck',
		() => {
			if (cardType) {
				if (cardType === 'amex' && $('input[name="ccCode"]').val().length === 4) {
					return true;
				}
				if (cardType !== 'amex' && $('input[name="ccCode"]').val().length === 3) {
					return true;
				}
				return false;
			}
			return true;
		},
		'Please enter valid CVV',
	);

	// Custom Validation Methods
	$.validator.addMethod(
		'regex',
		function(value, element, regexp) {
			const re = new RegExp(regexp);
			return this.optional(element) || !value.match(re);
		},
		'Please enter valid input.',
	);

	$.validator.addMethod("disabletests", function(value, element, param) {
		if ($.inArray(value, getConfig().blockedCardNumbers) == -1) {
			return true;
		} else {
			return false;
		}
	}, "Please enter valid Credit Card Number");

	$.validator.addMethod(
		'phoneUS',
		function(a, b) {
			return a = a.replace(/\s+/g, ''),
				this.optional(b) ||
				a.length > 9 &&
				a.match(/^(\+?1-?)?(\([2-9]([02-9]\d|1[02-9])\)|[2-9]([02-9]\d|1[02-9]))-?[2-9]([02-9]\d|1[02-9])-?\d{4}$/);
		},
		'Please specify a valid phone number',
	);

	// Additonal customer email validation to check that emails end at least with .xx
	$.validator.methods.email = function(value, element) {
		if (getConfig().gateway === 'sapphire') {
			return this.optional(element) || /@[a-z]+\.([a-z]{2,})/.test(value);
		}
		return this.optional(element) || /^[^@]+@[^@]+\.[^@\.]{2,}$/.test(value);
	};

	$.validator.addMethod(
		'checkPhone',
		function(a, b) { // val, elem
			if (getCountryEnv('cShipCountry') == 'US') {
				return a = a.replace(/\s+/g, ''),
					this.optional(b) || a.length > 9 && a.match(/^(\+?1-?)?(\([2-9]([02-9]\d|1[02-9])\)|[2-9]([02-9]\d|1[02-9]))-?[2-9]([02-9]\d|1[02-9])-?\d{4}$/);
			}

			const phoneno = /^\+?\d{8,19}$/;

			if ($(b).val().match(phoneno)) {
				return true;
			}
			return false;
		},
		'Please enter valid Phone Number',
	);

	$.validator.addMethod(
		'checkZIP',
		(a, b) => { // val, elem
			if (getCountryEnv('cShipCountry') == 'US') {
				const USZip = /(^\d{5}$)/;
				if ($(b).val().match(USZip)) {
					return true;
				}
				return false;
			}
			const phoneno = /(^[A-Za-z0-9]{3,8}$)/;
			if ($(b).val().match(phoneno)) {
				return true;
			}
			return false;
		},
		'Please enter valid Zip code',
	);

	$.validator.addMethod(
		'checkZIPBill',
		(a, b) => { // val, elem
			if (getCountryEnv('cBillCountry') == 'US') {
				const USZip = /(^\d{5}$)/;
				if ($(b).val().match(USZip)) {
					return true;
				}
				return false;
			}
			const phoneno = /(^[A-Za-z0-9]{3,8}$)/;
			if ($(b).val().match(phoneno)) {
				return true;
			}
			return false;
		},
		'Please enter valid Zip code',
	);

	function getInternationalMinLengthText(countryFieldName) {
		const countryCode = getInternationalMinLength(countryFieldName);
		if (defZipLen === 5) {
			return `Please enter ${countryCode} digit Zip`;
		}
		return `Please enter min. ${countryCode} digit Zip`;
	}

	if (getConfig().gateway === 'sapphire') {
		// Base Validation
		$('#payment_form').validate({
			ignore: ":hidden:not(input[name='ccExp']), select[name='ccMonth'], select[name='ccYear']",
			debug: true,
			submitHandler() {
				// PAYMENT SPOT
				$('#orderButton').hide();
				$('#orderButtonOff').show();
				$('.overlay, .processing').show();

				if (getConfig().provider == "konnektive") {
					doCompleteOrderSapphire();
				}
				//alert('Proceed with order');

			},
			errorClass: 'invalid',
			validClass: 'valid',
			errorPlacement(error, element) {
				error.appendTo(`#${element.attr('name')}_errorSpot`);
			},
			rules: {
				cShipAddress1: {
					regex: '@',
				},
				cShipZip: {
					required: true,
					checkZIP: true,
				},
				cEmail: {
					required: true,
					email: true,
				},
				cPhone2: {
					required: true,
					checkPhone: true,
				},
				cBillFName: {
					required: shipBillCheck,
				},
				cBillLName: {
					required: shipBillCheck,
				},
				cBillAddress1: {
					required: shipBillCheck,
					regex: '@',
				},
				cBillCity: {
					required: shipBillCheck,
				},
				cBillState: {
					required: shipBillCheck,
				},
				cBillZip: {
					required: shipBillCheck,
					checkZIPBill: true,
				},
				ccNum: {
					required: true,
					ccCheck: true,
					disabletests: true,
				},
				ccExp: {
					required: ccExpEmptyCheck,
					ccExpCheck: true,
				},
				ccCode: {
					required: true,
					cvvCheck: true,
				},
				sapphireAgreeTerms2: {
					required: terms2RequiredCheck
				},
				sapphireAgreeTerms: {
					required: termsRequiredCheck
				},
			},
			messages: {
				cShipFName: 'Please enter First Name',
				cShipLName: 'Please enter Last Name',
				cShipAddress1: {
					required: 'Please enter Address',
					regex: 'Please enter valid mailing address (@ is not allowed)',
				},
				cShipCity: 'Please enter City',
				cShipState: 'Please enter State',
				cShipZip: {
					required: 'Please enter Zip',
				},
				cPhone2: {
					required: 'Please enter Phone Number',
					checkPhone: 'Please enter valid Phone Number',
				},
				cEmail: {
					required: 'Please enter Email',
					email: 'Please enter a valid Email',
				},
				cBillFName: 'Please enter First Name',
				cBillLName: 'Please enter Last Name',
				cBillAddress1: {
					required: 'Please enter Address',
					regex: 'Please enter valid mailing address (@ is not allowed)',
				},
				cBillCity: 'Please enter City',
				cBillState: 'Please enter State',
				cBillZip: {
					required: 'Please enter Zip',
				},
				sapphireAgreeTerms2: {
					required: 'You must accept Terms',
				},
				sapphireAgreeTerms: {
					required: 'You must accept Terms',
				},
				ccExp: {
					required: 'Please enter Expiration Date',
					ccExpCheck: 'Please enter valid Expiration Date',
				},
				ccNum: {
					required: 'Please enter Credit Card Number',
					ccCheck: 'Please enter valid Credit Card Number',
				},
				ccCode: {
					required: 'Please enter CVV',
					cvvCheck: 'Please enter valid CVV',
				},
			},
		});
	} else {
/* ONLINE VALIDATIONS */

		var emailOnlineValidated = false;
		var phoneOnlineValidated = false;

		var buttonClicked = false;
		$('#shipping_form #cEmail[type=email], #shipping_form #cEmail[type=text],  #payment_form #cEmail[type=email], #payment_form #cEmail[type=text]').blur(function(){
			if($('#cEmail').val().length){
				if(getConfig().onlineEmailValidation){
				validateOnlineEmail($('#cEmail').val());
				} else {

				}
			}
		});

	$('#shipping_form #cPhone2[type=tel], #shipping_form #cPhone2[type=text],  #payment_form #cPhone2[type=tel], #payment_form #cPhone2[type=text]').blur(function(){
			if($('#cPhone2').val().length){
				if(getConfig().onlinePhoneValidation){
				validateOnlinePhone($('#cPhone2').val());
				} else {

				}
			}
		});

		$('#shipping_form #cEmail[type=email], #shipping_form #cEmail[type=text],  #payment_form #cEmail[type=email], #payment_form #cEmail[type=text]').focus(function(){
			$(this).removeClass("invalid").removeClass("valid").removeClass("pendingvalidation");
			emailOnlineValidated = false;
			debug("emailOnlineValidated " + emailOnlineValidated);
		});

		$('#shipping_form #cPhone2[type=tel], #shipping_form #cPhone2[type=text],  #payment_form #cPhone2[type=tel], #payment_form #cPhone2[type=text]').focus(function(){
			$(this).removeClass("invalid").removeClass("valid").removeClass("pendingvalidation");
			phoneOnlineValidated = false;
			debug("phoneOnlineValidated " + phoneOnlineValidated);
		});


		function validateOnlineEmail(value, callback = ""){
			$('#cEmail').removeClass("invalid").removeClass("valid").addClass("pendingvalidation");
			$('#cEmail_errorSpot').hide().html('<label id="cEmail-error" class="invalid" for="cEmail"></label>');
			emailOnlineValidated = false;
			const settings = {
				url: `${getConfig().emailValidationURL}`,
				method: 'POST',
				crossDomain: false,
				timeout: 0,
				data: JSON.stringify({
					email: value,
				}),
				headers: {
					"accept": 'application/json',
					"content-type": 'application/json',
					"X-SESSION-ID": ''
				}
			};
			 $.ajax(settings).done((response) => {
				debug(response);
				if(response.status == 'valid'){
					emailOnlineValidated = true;
					$('#cEmail').removeClass("pendingvalidation").removeClass("invalid").addClass("valid");
					if(callback){
						runFormAction(callback);
					}
				}
				if(response.status == 'invalid'){
					emailOnlineValidated = false;
					$('#cEmail').removeClass("pendingvalidation").addClass("invalid");
					$('#cEmail_errorSpot').html('<label id="cEmail-error" class="invalid" for="cEmail">' + response.message + '</label>').show();
					if(response.did_you_mean){
						suggestUserEmail(response.did_you_mean);
					}
				}
			}).fail(() => {
				emailOnlineValidated = false;
				$('#cEmail').removeClass("pendingvalidation").addClass("invalid");
				$('#cEmail_errorSpot').html('<label id="cEmail-error" class="invalid" for="cEmail">Please enter valid Email</label>').show();
			});
		}

		function validateOnlinePhone(value, callback = ""){
			$('#cPhone2').removeClass("invalid").removeClass("valid").addClass("pendingvalidation");
			$('#cPhone2_errorSpot').hide().html('<label id="cPhone2-error" class="invalid" for="cPhone2"></label>');
			phoneOnlineValidated = false;

			let intermediateCheck = value.length > 9 && value.match(/^(\+?1-?)?(\([2-9]([02-9]\d|1[02-9])\)|[2-9]([02-9]\d|1[02-9]))-?[2-9]([02-9]\d|1[02-9])-?\d{4}$/);
			if(intermediateCheck){

			const settings = {
				url: `${getConfig().phoneValidationURL}`,
				method: 'POST',
				crossDomain: false,
				timeout: 0,
				data: JSON.stringify({
					phone_number: value,
				}),
				headers: {
					"accept": 'application/json',
					"content-type": 'application/json',
					"X-SESSION-ID": ''
				}
			};
			 $.ajax(settings).done((response) => {
				debug(response);
				if(response.status == 'valid'){
						phoneOnlineValidated = true;
						$('#cPhone2').removeClass("pendingvalidation").removeClass("invalid").addClass("valid");
						$('#cPhone2_errorSpot').hide().html('<label id="cPhone2-error" class="invalid" for="cPhone2"></label>');
						if(callback){
							runFormAction(callback);
						}
				}
				if(response.status == 'invalid'){
					phoneOnlineValidated = false;
					$('#cPhone2').removeClass("pendingvalidation").addClass("invalid");
					$('#cPhone2_errorSpot').html('<label id="cPhone2-error" class="invalid" for="cPhone2">Please enter valid Phone Number</label>').show();
				}
			}).fail(() => {
				phoneOnlineValidated = false;
				$('#cPhone2').removeClass("pendingvalidation").addClass("invalid");
				$('#cPhone2_errorSpot').html('<label id="cPhone2-error" class="invalid" for="cPhone2">Please enter valid Phone Number</label>').show();
			});

			} else {
				phoneOnlineValidated = false;
				$('#cPhone2').removeClass("pendingvalidation").addClass("invalid");
				$('#cPhone2_errorSpot').html('<label id="cPhone2-error" class="invalid" for="cPhone2">Please enter valid Phone Number</label>').show();
			}

		}


		// Dispatch a form action by name, without eval.
		//
		// This used to be eval("do" + formName + "Action" + "()"). That relies on
		// the identifier still existing under that exact name in the enclosing
		// scope at runtime — which the bundle's minifier does not guarantee: it
		// rewrites `function doShippingAction(){}` into an assignment inside a
		// sequence expression. When the lookup fails the submit does nothing at
		// all — no lead, no navigation, no error — so it is invisible until
		// someone notices orders have stopped arriving. Referencing the
		// functions directly keeps the bundler and minifier honest.
		function runFormAction(actionName) {
			if (actionName === 'doShippingAction') return doShippingAction();
			if (actionName === 'doPaymentAction') return doPaymentAction();
			debug('Unknown form action requested: ' + actionName);
			return undefined;
		}

		function validateFormUniversal(formName){
			buttonClicked = true;

			if( getConfig().onlineEmailValidation == false || emailOnlineValidated || !$('#cEmail[type=email], #cEmail[type=text]').val()) { // checking if we need validate Email
				emailOnlineValidated = true;
			} else {
				emailOnlineValidated = false;
			}

			if( getConfig().onlinePhoneValidation == false || phoneOnlineValidated || getCountryEnv('cShipCountry') != 'US' || !$('#cPhone2[type=tel], #cPhone2[type=text]').val()) { // checking if we need validate Phone
				phoneOnlineValidated = true;
			} else {
				phoneOnlineValidated = false;
			}

	//		debug("emailOnlineValidated " + emailOnlineValidated + " phoneOnlineValidated " + phoneOnlineValidated);

			if(emailOnlineValidated && phoneOnlineValidated){ // everything is validated
				runFormAction("do" + formName + "Action");
			} else { // not all required fields are online validated
				if(getConfig().onlineEmailValidation && !emailOnlineValidated){
					debug('Email Validation with callback');
					validateOnlineEmail($('#cEmail[type=email], #cEmail[type=text]').val(), "do" + formName + "Action");
				}

				if(getConfig().onlinePhoneValidation && !phoneOnlineValidated){
					debug(' Phone Validation with callback');
					validateOnlinePhone($('#cPhone2[type=tel], #cPhone2[type=text]').val(), "do" + formName + "Action");
				}
			}

		}


		function doShippingAction(){
			if ($('#shipping_form').hasClass('knk-submitting')) { debug('Duplicate submit blocked (shipping)'); return; }
			$('#shipping_form').addClass('knk-submitting');
			debug("Processing Shipping form .....");

			cleanUpUserInput();
			$('#orderButton').hide();
			$('#orderButtonOff').show();
			$('.overlay, .processing').show();
			if (getConfig().provider == "konnektive") {
				const debouncedKNKLead = debounce(() => konnektive_new_lead()); debug('Debouncing...');
				debouncedKNKLead();
			}
		}

		function doPaymentAction(){
			if ($('#payment_form').hasClass('knk-submitting')) { debug('Duplicate submit blocked (payment)'); return; }
			$('#payment_form').addClass('knk-submitting');
			debug("Processing Payment form .....");

			cleanUpUserInput();
			$('#orderButton').hide();
			$('#orderButtonOff').show();
			$('.overlay, .processing').show();

			if (getConfig().provider == "konnektive") {
				const debouncedKNKCompleteOrder = debounce(() => doCompleteOrder()); debug('Debouncing...');
				debouncedKNKCompleteOrder();
			}
		}

/* ONLINE VALIDATIONS */

		// FORMS Validation
		$('#payment_form').validate({
			ignore: ":hidden:not(input[name='ccExp']), select[name='ccMonth'], select[name='ccYear']",
			debug: true,
			submitHandler() {
				// PAYMENT SPOT
				validateFormUniversal('Payment');
				return false;

			},
			errorClass: 'invalid',
			validClass: 'valid',
			errorPlacement(error, element) {
				error.appendTo(`#${element.attr('name')}_errorSpot`);
			},
			rules: {
				cShipAddress1: {
					regex: '@',
					minlength: 5,
				},
				cShipZip: {
					required: true,
					checkZIP: true,
				},
				cEmail: {
					required: true,
					email: true,
				},
				cPhone2: {
					required: true,
					checkPhone: true,
				},
				cBillFName: {
					required: shipBillCheck,
				},
				cBillLName: {
					required: shipBillCheck,
				},
				cBillAddress1: {
					required: shipBillCheck,
					regex: '@',
					minlength: 5,
				},
				cBillCity: {
					required: shipBillCheck,
				},
				cBillState: {
					required: shipBillCheck,
				},
				cBillCountry: {
					required: shipBillCheck,
				},
				cBillZip: {
					required: shipBillCheck,
					checkZIPBill: true,
				},
				ccNum: {
					required: true,
					ccCheck: true,
					disabletests: true,
				},
				ccExp: {
					required: ccExpEmptyCheck,
					ccExpCheck: true,
				},
				ccCode: {
					required: true,
					cvvCheck: true,
				},
			},
			messages: {
				cShipFName: 'Please enter First Name',
				cShipLName: 'Please enter Last Name',
				cShipAddress1: {
					required: 'Please enter Address',
					regex: 'Please enter valid mailing address (@ is not allowed)',
					minlength: 'Address is too short',
				},
				cShipCity: 'Please enter City',
				cShipState: 'Please enter State',
				cShipCountry: 'Please enter Country',
				cShipZip: {
					required: 'Please enter Zip',
				},
				cPhone2: {
					required: 'Please enter Phone Number',
					checkPhone: 'Please enter valid Phone Number',
				},
				cEmail: {
					required: 'Please enter Email',
					email: 'Please enter a valid Email',
				},
				cBillFName: 'Please enter First Name',
				cBillLName: 'Please enter Last Name',
				cBillAddress1: {
					required: 'Please enter Address',
					regex: 'Please enter valid mailing address (@ is not allowed)',
					minlength: 'Address is too short',
				},
				cBillCountry: 'Please enter Country',
				cBillCity: 'Please enter City',
				cBillState: 'Please enter State',
				cBillZip: {
					required: 'Please enter Zip',
				},
				ccExp: {
					required: 'Please enter Expiration Date',
					ccExpCheck: 'Please enter valid Expiration Date',
				},
				ccNum: {
					required: 'Please enter Credit Card Number',
					ccCheck: 'Please enter valid Credit Card Number',
				},
				ccCode: {
					required: 'Please enter CVV',
					cvvCheck: 'Please enter valid CVV',
				},
			},
		});

		if($('#cEmail').length) { // check if shipping_form is correct one and has email if not - skip validation

		$('#shipping_form').validate({
			ignore: ":hidden:not(input[name='ccExp']), select[name='ccMonth'], select[name='ccYear']",
			debug: false,
			submitHandler() {
				setTimeout(() => {
					// SHIPPING INFO CATCH SPOT
					validateFormUniversal('Shipping');
					return false;

				}, 100);
			},
			errorClass: 'invalid',
			validClass: 'valid',
			errorPlacement(error, element) {
				error.appendTo(`#${element.attr('name')}_errorSpot`);
			},
			rules: {
				cEmail: {
					required: true,
					email: true,
				},
				cPhone2: {
					required: true,
					checkPhone: true,
				},
				cShipFName: {
					required: true,
				},
				cShipLName: {
					required: true,
				},
				cShipAddress1: {
					required: true,
					regex: '@',
					minlength: 5,
				},
				cShipCity: {
					required: true,
				},
				cShipState: {
					required: true,
				},
				cShipCountry: {
					required: true,
				},
				cShipZip: {
					required: true,
					checkZIP: true,
				},
			},
			messages: {
				cShipFName: 'Please enter First Name',
				cShipLName: 'Please enter Last Name',
				cShipAddress1: {
					required: 'Please enter Address',
					regex: 'Please enter valid mailing address (@ is not allowed)',
					minlength: 'Address is too short',
				},
				cShipCountry: 'Please enter Country',
				cShipCity: 'Please enter City',
				cShipState: 'Please enter State',
				cShipZip: {
					required: 'Please enter Zip',
				},
				cPhone2: {
					required: 'Please enter Phone Number',
					checkPhone: 'Please enter valid Phone Number',
				},
				cEmail: {
					required: 'Please enter Email',
					email: 'Please enter a valid Email',
				},
			},
		});

		}

	}

});
